"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformExtension1Schema = void 0;
exports.PlatformExtension1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/platform-extension/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "PlatformExtension1",
    "description": "This service is used to add custom made features within regular platform content. It's highly flexible and should be used with caution.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:platform-extension:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "platformExtensionId": {
                    "type": "string",
                    "description": "Used to reference to the respective Platform extension."
                },
                "lcmId": {
                    "type": "string",
                    "description": "The LCM id of a given extension to allow for lifecycle management."
                }
            },
            "required": [
                "platformExtensionId",
                "lcmId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9wbGF0Zm9ybS1leHRlbnNpb24vMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSx3QkFBd0IsR0FBRztJQUN0QyxLQUFLLEVBQUUsdUZBQXVGO0lBQzlGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLG9CQUFvQjtJQUM3QixhQUFhLEVBQUUseUlBQXlJO0lBQ3hKLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLCtDQUErQzthQUNoRDtTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1oscUJBQXFCLEVBQUU7b0JBQ3JCLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUseURBQXlEO2lCQUN6RTtnQkFDRCxPQUFPLEVBQUU7b0JBQ1AsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxvRUFBb0U7aUJBQ3BGO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YscUJBQXFCO2dCQUNyQixPQUFPO2FBQ1I7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==